import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  OnDestroy,
  ViewChildren,
  QueryList,
  ElementRef,
  Output,
  EventEmitter,
  ViewChild,
  HostListener,
  TemplateRef,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddressBookService } from "src/app/_core/_services/address-book/address-book.service";
import { EditStatusContactModalComponent } from "src/app/modules/profile/edit-status-contact-modal/edit-status-contact-modal.component";
import { BehaviorSubject, interval, Subscription } from "rxjs";
import { startWith, switchMap } from "rxjs/operators";
import { AudioModalComponent } from "src/app/_metronic/layout/components/modals/audio-modal/audio-modal.component";
import { FiltersModalComponent } from "src/app/_metronic/layout/components/modals/filters-modal/filters-modal.component";
import { ErrorModalComponent } from "src/app/_metronic/layout/components/modals/error-modal/error-modal.component";
import { TranslateService } from "@ngx-translate/core";
import { CampaignsService } from "src/app/_core/_services/campaigns/campaigns.service";
import { RetryContactModalComponent } from "src/app/_metronic/layout/components/modals/retry-contact-modal/retry-contact-modal.component";
import { AlertService } from "src/app/_core/_services/alert.service";
import { TimezoneDatePipe } from "src/app/_metronic/shared/pipes/timezone-date.pipe";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { ToastService } from "src/app/_core/_services/toast.service";
import { debounce } from "lodash";
import { TagsService } from "src/app/_core/_services/tags/tags.service";
import { AddTagModalComponent } from "src/app/_metronic/layout/components/modals/add-tags-modal/add-tag-modal/add-tag-modal.component";
import { AuthService } from "src/app/modules/auth/services/auth.service";
import { HttpErrorResponse } from "@angular/common/http";
import { PhoneNumbersService } from "src/app/_core/_services/phone-numbers/phone-numbers.service";

export interface Tag {
  id: number;
  value: string;
  color: string;
}

// Interfejs definiujący strukturę kampanii
interface Campaign {
  id: number;
  type: number;
  title: string;
  owner: number;
  public: string;
  created: string;
  modified: string;
  status: number;
  phone: string;
  duration: number;
  call_number: number;
  call_at?: string;
  module?: string;
  retry?: number;
  tags: any[];
  scheduled?: string | null;
  isFavourite: boolean;

  // Dodatkowe pola dotyczące kampanii Eliot
  eliotID?: string;
  eliotName?: string;
  eliotSurname?: string;
  eliotLink?: string;
  eliotCompany?: string;
  eliotSync?: string;
  eliotSyncDate?: string | number;

  // Pola dla kampanii IntegromatInvent1
  contactCampaignFrom?: string;
  contactEmail?: string;
  contactJobFor?: string;
  contactLanguageGrade?: string;
  contactName?: string;
  contactSource?: string;
  contactSubmit?: string;
  contactSurname?: string;

  expanded?: boolean;
  showFullId?: boolean;
  chatMessagesSubject: BehaviorSubject<ChatMessage[]>;

  expandedIndex?: number | null;
  tagsLetters: any[];
}

// Interfejs wiadomości w czacie
interface ChatMessage {
  created: string;
  id: number;
  modified: string;
  person: string;
  value: string;
}

@Component({
  selector: "app-tables-widget10",
  templateUrl: "./tables-widget10.component.html",
  styleUrls: ["./tables-widget10.component.scss"],
})
export class TablesWidget10Component implements OnInit, OnChanges, OnDestroy {
  @Output() retryContactEvent = new EventEmitter<string>(); // Emitowanie zdarzenia ponowienia kontaktu

  @Input() campaignPublic: string; // Publiczny identyfikator kampanii
  @Input() campaignName: string; // Nazwa kampanii
  @Input() campaignModule: string | null; // Nazwa modułu kampanii
  @Input() filters: any; // Filtry używane w widoku
  @Input() refresh: boolean; // Flaga do odświeżenia widoku
  @Input() selectedCampaignType: number | null = null;
  @Input() campaignType: number | null = null;
  @Output() campaignTypeChange = new EventEmitter<number | null>();

  @ViewChildren("chatRow") chatRows: QueryList<ElementRef>; // Referencje do wierszy czatu
  @ViewChild("copyToast", { static: true }) copyToast: ElementRef; // Referencja do elementu do kopiowania toastów
  @ViewChild("filterDropdown") filterDropdown: ElementRef; // Reference to the filter dropdown
  @ViewChild("filterButton") filterButton: ElementRef;
  @ViewChild("topScrollbar") topScrollbar!: ElementRef;
  @ViewChild("tableContainer") tableContainer!: ElementRef;
  @ViewChild("chatModal") chatModal: TemplateRef<any>;

  private loadCampaignsDebounced = debounce(this.loadCampaigns.bind(this), 200);

  phoneColorMap: Map<string, string> = new Map();
  ApiUserId: number | null = null;

  isFilterVisible = false; // Flaga, czy filtry są widoczne
  filtersApplied = false; // Flaga, czy filtry zostały zastosowane

  copyInProgress: boolean = false; // Flaga stanu kopiowania
  loadingChatMessages: boolean = false; // Flaga stanu ładowania wiadomości czatu
  tagsLetters: any[] = []; // Litery tagów do wyświetlania
  expandedIndex: number | null = null; // Indeks rozwiniętego elementu

  copiedPhone: string = ""; // Skopiowany numer telefonu
  tooltipMessage: string = "Click to copy"; // Komunikat narzędziowy przy kopiowaniu
  showToast = false; // Flaga stanu wyświetlania powiadomienia

  currentPage: number = 1; // Aktualna strona
  pageSize: number = 20; // Rozmiar strony (ilość elementów na stronie)
  totalItems: number = 0; // Całkowita liczba elementów
  totalPages: number = 1; // Całkowita liczba stron
  campaigns: Campaign[] = []; // Lista kampanii
  startItem: number = 1; // Indeks początkowy elementu
  endItem: number = 10; // Indeks końcowy elementu
  pageNumbers: (number | string)[] = []; // Lista numerów stron

  isMenuVisible = false; // Flaga stanu widoczności menu
  isModalVisible = false; // Flaga stanu widoczności modala
  selectedCampaign: Campaign | null = null; // Wybrana kampania
  pollingSubscription: Subscription | undefined; // Subskrypcja do mechanizmu polling
  autoRefreshEnabled = false; // Opcjonalne auto-odswiezanie widoku (co 10s)
  private autoRefreshSub?: Subscription; // Subskrypcja interwalu auto-odswiezania
  private readonly AUTO_REFRESH_MS = 10000; // Interwal auto-odswiezania
  isLoading: boolean = true; // Flaga stanu ładowania (chowa tabele — pierwsze wejscie/filtr/paginacja)
  isReloading: boolean = false; // Odswiezanie "w miejscu" (manualne/auto) — tabela zostaje, brak skoku scrolla
  pollingSubscriptions: { [key: string]: Subscription } = {}; // Subskrypcje dla różnych kampanii
  expandedCampaign: Campaign | null = null; // Aktualnie rozwinięta kampania
  isSuccess: boolean = true; // Flaga stanu sukcesu operacji
  errorMessage: string = "";

  //audio
  currentAudio: HTMLAudioElement | null = null;
  currentCampaignPlaying: Campaign | null = null;
  isPaused: boolean = false;
  pausedTime: number = 0;

  // Zmienne do wyświetlania pełnych identyfikatorów i nazw
  showFullId: string = "";
  showFullEliotID: string = "";
  showFullEliotName: string = "";
  showFullEliotSurname: string = "";
  showFullEliotSync: string = "";
  showFullEliotSyncDate: string = "";
  showFullEliotLink: string = "";
  showFullEliotCompany: string = "";

  showFullContactCampaignFrom: string = "";
  showFullContactEmail: string = "";
  showFullContactJobFor: string = "";
  showFullContactLanguageGrade: string = "";
  showFullContactName: string = "";
  showFullContactSource: string = "";
  showFullContactSubmit: string = "";
  showFullContactSurname: string = "";

  sortBy: string = ""; // Kolumna sortowania
  sortOrder: string = "asc"; // Kierunek sortowania

  isAudioModalVisible = false; // Flaga stanu widoczności modala audio
  currentAudioUrl: string | null = null; // URL bieżącego audio
  isAudioDialogOpen = false; // Flaga stanu otwartego dialogu audio

  private debounceLoadCampaigns = debounce(this.loadCampaigns.bind(this), 300);

  // Tagi dostępne dla kampanii — ładowane przy zmianie campaignPublic
  availableTags: Tag[] = [];
  private tagsSubscription: Subscription | null = null;

  // Domyślne wartości filtrów
  filterValues = {
    type: "",
    status: "",
    phone: "",
    call_number: null,
    call_at: "",
    created: "",
    modified: "",
    scheduled: null,
    tag: "",
  };

  tempFilterValues = {
    type: "",
    status: "",
    phone: "",
    call_number: null,
    call_at: "",
    created: "",
    modified: "",
    scheduled: null,
    tag: "",
  };

  constructor(
    private addressBookService: AddressBookService,
    private phoneNumbersService: PhoneNumbersService,
    private tagsService: TagsService,
    private campaignsService: CampaignsService,
    public authService: AuthService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private alertService: AlertService,
    private timezoneDatePipe: TimezoneDatePipe,
    private dialog: MatDialog,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  // Funkcja inicjalizacyjna, wykonywana po załadowaniu komponentu

  ngOnInit(): void {
    // Initialize campaigns to an empty array to avoid undefined issues
    this.campaigns = [];
    this.ApiUserId = this.authService.getApiUserIdFromAuthService();
    if (this.ApiUserId) {
      this.loadUserPreferences();
      this.loadPhoneBadgeColors();
    }
  }

  // Funkcja wywoływana, gdy zmieniają się dane wejściowe (@Input)
  ngOnChanges(changes: SimpleChanges): void {
    let shouldLoadCampaigns = false;

    // Rozpocznij polling, jeśli zmienia się campaignPublic i polling nie został jeszcze uruchomiony
    if (changes.campaignPublic && changes.campaignPublic.currentValue) {
      // Załaduj dostępne tagi dla nowej kampanii
      if (this.tagsSubscription) {
        this.tagsSubscription.unsubscribe();
      }
      this.tagsSubscription = this.tagsService
        .getAvailableTags(this.campaignPublic)
        .subscribe((tags) => {
          this.availableTags = tags;
          this.cdr.detectChanges();
        });
    }

    // Jeśli flaga refresh się zmieniła
    // if (changes.refresh?.currentValue) {
    //   this.filtersApplied ? this.applyFilters() : this.loadCampaigns();
    // }
    // Jedno, wspolne, debounce'owane zaladowanie — niezaleznie ile @Input zmieni sie naraz
    // (campaignPublic, filters, refresh), poleci dokladnie jedno zadanie.
    if (
      changes.campaignPublic?.currentValue ||
      (changes.refresh && !changes.refresh.firstChange) || // reaguj na KAZDA zmiane flagi refresh (toggle true<->false)
      changes.filters?.currentValue
    ) {
      this.loadCampaignsDebounced();
    }

    // Wywołaj loadCampaignsDebounced tylko wtedy, gdy polling nie został uruchomiony lub jeśli inne zmiany tego wymagają
    if (shouldLoadCampaigns && !this.pollingSubscription) {
      this.loadCampaignsDebounced(); // Funkcja debounced dla nie-pollingowych zmian
    }
  }

  // Funkcja wykonywana, gdy komponent zostanie zniszczony
  ngOnDestroy(): void {
    this.stopAllPolling(); // Zatrzymaj wszystkie pollingi
    this.stopAutoRefresh(); // Zatrzymaj auto-odswiezanie
    this.campaigns.forEach((campaign) =>
      campaign.chatMessagesSubject.complete()
    );

    if (this.isAudioDialogOpen) {
      this.dialog.closeAll(); // Zamknij wszystkie otwarte dialogi
    }
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe(); // Anuluj subskrypcję pollingu
    }
    if (this.tagsSubscription) {
      this.tagsSubscription.unsubscribe();
    }

    this.currentCampaignPlaying = null;
    this.currentAudio = null;
    this.cdr.detach(); // Odłącz ChangeDetectorRef
  }

  loadUserPreferences(): void {
    if (this.ApiUserId !== null) {
      this.campaignsService
        .loadUserPreferences(this.ApiUserId, "table_filter_settings")
        .subscribe(
          (preferences) => {
            if (preferences && Object.keys(preferences).length > 0) {
              this.filters = { ...this.filters, ...preferences };
            } else {
              // If no preferences, load table without applying filters
              this.filters = {
                showID: false,
                showType: true,
                showCreated: true,
                showModified: false,
                showCalledAt: true,
                showStatus: true,
                showPhone: true,
                showDuration: true,
                showScheduled: false,
                showAttempts: true,
                showShortcuts: false,
                showQuickActions: false,
                showEliotID: false,
                showEliotName: false,
                showEliotSurname: false,
                showEliotCompany: false,
                showEliotLink: false,
                showEliotSync: false,
                showEliotSyncDate: false,
                showContactCampaignFrom: false,
                showContactEmail: false,
                showContactJobFor: false,
                showContactLanguageGrade: false,
                showContactName: false,
                showContactSource: false,
                showContactSubmit: false,
                showContactSurname: false,
              };
            }
            this.cdr.detectChanges();
          },
          (error) => {
            console.error("Failed to load user preferences:", error);
          }
        );
    } else {
      console.error("Cannot load preferences: User ID is null.");
    }
  }

  // Funkcja ustawiająca filtr na podstawie numeru telefonu
  setPhoneFilter(phone: string, event: Event): void {
    event.stopPropagation(); // Zapobiegaj rozwijaniu wiersza po kliknięciu numeru telefonu
    this.stopAllPolling();
    this.filterValues.phone = phone; // Ustaw numer telefonu w filterValues
    this.tempFilterValues.phone = phone; // Upewnij się, że tymczasowy filtr również zawiera numer telefonu

    this.applyFilters(); // Zastosuj filtr od razu po ustawieniu numeru telefonu
    this.cdr.detectChanges(); // Wymuś detekcję zmian, aby natychmiast zaktualizować UI
  }

  // Funkcja zmieniająca widoczność filtrów
  toggleFilterVisibility(): void {
    this.isFilterVisible = !this.isFilterVisible; // Przełącz widoczność filtrów
  }

  // Open filter modal to adjust table columns visibility
  openFilterModal(): void {
    const modalRef = this.modalService.open(FiltersModalComponent, {
      centered: true,
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.filters = { ...this.filters };
    modalRef.componentInstance.campaignModule = this.campaignModule;

    modalRef.result
      .then((newFilters) => {
        if (newFilters) {
          this.filters = newFilters;
          this.saveUserPreferences(); // Save preferences when filters are changed
          this.cdr.detectChanges();
        }
      })
      .catch(() => {});
  }

  saveUserPreferences(): void {
    // Check if ApiUserId is not null before saving preferences
    this.ApiUserId = this.authService.getApiUserIdFromAuthService();
    if (this.ApiUserId !== null) {
      this.campaignsService
        .saveUserPreferences(
          this.ApiUserId,
          "table_filter_settings",
          this.filters
        )
        .subscribe(
          () => console.log("Preferences saved successfully."),
          (error) => console.error("Error saving preferences:", error)
        );
    } else {
      console.error("Cannot save preferences: User ID is null.");
    }
  }

  // Funkcja stosująca filtry i ukrywająca dropdown filtrów
  applyFilters(): void {
    // Zastosuj tymczasowe filtry do właściwych wartości filterValues
    this.filterValues = { ...this.tempFilterValues };

    const filters = this.buildFilters();

    // WAZNE: ustaw filtersApplied PRZED loadCampaigns — loadCampaigns czyta te flage,
    // by zdecydowac czy wyslac filtry. Gdy uzytkownik wyczysci wszystkie filtry
    // (np. "wszystkie statusy"), filtersApplied=false -> loadCampaigns przeladuje BEZ filtrow
    // (zamiast zostawiac stare, przefiltrowane dane z komunikatem "No filters applied").
    this.filtersApplied = Object.keys(filters).length > 0;
    this.isFilterVisible = false;
    this.errorMessage = ""; // Wyczyść wcześniejsze błędy
    this.stopAutoRefresh(); // Zastosowanie filtra wylacza auto-odswiezanie
    this.currentPage = 1; // Zawsze wracaj na 1. strone po zmianie filtra (inaczej zostaje zapamietana strona np. 3 i przy mniejszej liczbie wynikow widac "brak kontaktow")
    this.loadCampaigns(); // Zawsze przeladuj (z filtrami lub bez)
    this.cdr.detectChanges();
  }

  // Metoda resetująca filtry
  resetFilters(): void {
    // Zresetuj wartości filtrów
    this.tempFilterValues = {
      type: "",
      status: "",
      phone: "",
      call_number: null,
      call_at: "",
      created: "",
      modified: "",
      scheduled: null,
      tag: "",
    };

    this.filterValues = { ...this.tempFilterValues }; // Zresetuj również właściwe wartości filterValues

    this.currentPage = 1;
    this.sortBy = "";
    this.sortOrder = "asc";

    // Wyczyść komunikaty o błędach i zresetuj flagi
    this.filtersApplied = false;
    this.errorMessage = "";

    // Ukryj dropdown filtrów
    this.isFilterVisible = false;

    // Zawsze przeladuj dane bez filtrow (auto-polling wylaczony, wiec robimy to jawnie).
    // filtersApplied jest juz false, wiec loadCampaigns wysle puste {filters:{}}.
    this.loadCampaigns();

    this.cdr.detectChanges(); // Wymuś detekcję zmian
  }

  @HostListener("document:click", ["$event.target"])
  onClickOutside(targetElement: EventTarget | null): void {
    if (!(targetElement instanceof HTMLElement)) {
      return;
    }
    const clickedInsideDropdown =
      this.filterDropdown?.nativeElement.contains(targetElement);
    const clickedInsideButton =
      this.filterButton?.nativeElement.contains(targetElement);

    if (
      !clickedInsideDropdown &&
      !clickedInsideButton &&
      this.isFilterVisible
    ) {
      this.isFilterVisible = false; // Zamknij dropdown, jeśli kliknięto poza przyciskiem i dropdownem
    }
  }

  // Funkcja wyświetlająca podpowiedzi dla numerów telefonów
  getTooltipMessage(phone: string): string {
    return this.copiedPhone === phone
      ? this.translate.instant("TOOLTIP.COPIED")
      : this.translate.instant("TOOLTIP.CLICK_TO_COPY");
  }

  getTagsLetter(index: number) {
    return this.tagsLetters[index % this.tagsLetters.length];
  }

  openAddTagModal(campaign: Campaign, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    const modalRef = this.modalService.open(AddTagModalComponent, {
      centered: true,
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.publicId = this.campaignPublic;

    modalRef.componentInstance.tagSelected.subscribe((selectedTags: Tag[]) => {
      selectedTags.forEach((tag) => {
        if (this.isTagAlreadyAdded(campaign, tag)) {
          // Pokaż komunikat, jeśli tag już istnieje
          this.translate.get("TAG.ALREADY_EXISTS").subscribe((res: string) => {
            this.alertService.warning(res); // Wyświetl przetłumaczony komunikat
          });
        } else {
          this.addTagToCampaign(campaign, tag.id); // Dodaj tag, jeśli nie jest zduplikowany
        }
      });
      modalRef.close(); // Zamknij modal po przetworzeniu tagów
    });
  }

  // Funkcja dodająca tag do kampanii bez rozwijania
  addTagToCampaign(campaign: Campaign, tagId: number): void {
    this.tagsService.markTag(campaign.public, tagId).subscribe(
      (response) => {
        campaign.tagsLetters.push(response.data); // Dodaj tag natychmiast
        campaign.expandedIndex = null; // Upewnij się, że żaden tag nie jest rozwinięty po dodaniu nowego
        this.cdr.detectChanges(); // Wymuś detekcję zmian
        this.refreshTable(); // Odswiez widok po dodaniu tagu (auto-polling wylaczony)
      },
      (error) => {
        console.error("Błąd dodawania tagu:", error);
      }
    );
  }

  isTagAlreadyAdded(campaign: Campaign, tag: Tag): boolean {
    return campaign.tagsLetters.some(
      (existingTag) => existingTag.fullName === tag.value
    );
  }

  // Funkcja do rozwijania/zwijania tagu
  toggleTagExpansion(
    campaign: Campaign,
    index: number,
    event: MouseEvent
  ): void {
    event.stopPropagation();

    if (campaign.expandedIndex !== index) {
      campaign.expandedIndex = index; // Rozwiń kliknięty tag
    } else {
      campaign.expandedIndex = null; // Zwiń kliknięty tag, jeśli jest już rozwinięty
    }

    this.campaigns.forEach((c) => {
      if (c.id !== campaign.id) {
        c.expandedIndex = null; // Zwiń tagi w innych kampaniach
      }
    });

    this.cdr.detectChanges(); // Wymuś detekcję zmian
  }

  deleteTag(campaign: Campaign, index: number, event: MouseEvent): void {
    event.stopPropagation();

    if (campaign.tagsLetters && campaign.tagsLetters.length > index) {
      const tagPublicId = campaign.tags[index]?.public;

      this.translate
        .get([
          "TAG.DELETE_CONFIRM_TITLE",
          "TAG.DELETE_CONFIRM_MESSAGE",
          "TAG.DELETE_SUCCESS",
          "TAG.DELETE_ERROR",
          "TAG.INVALID_TAG_INDEX",
        ])
        .subscribe((translations) => {
          this.alertService.confirm(
            translations["TAG.DELETE_CONFIRM_TITLE"],
            translations["TAG.DELETE_CONFIRM_MESSAGE"],
            () => {
              this.tagsService.unmarkTag(tagPublicId).subscribe(
                (response) => {
                  campaign.tagsLetters.splice(index, 1); // Usuń tag z UI po udanym usunięciu
                  campaign.expandedIndex = null; // Upewnij się, że żaden tag nie jest rozwinięty
                  this.alertService.success(translations["TAG.DELETE_SUCCESS"]);
                  this.cdr.detectChanges(); // Wymuś aktualizację UI
                  this.refreshTable(); // Odswiez widok po usunieciu tagu (auto-polling wylaczony)
                },
                (error) => {
                  this.alertService.error(translations["TAG.DELETE_ERROR"]);
                }
              );
            }
          );
        });
    } else {
      this.translate.get("TAG.INVALID_TAG_INDEX").subscribe((translation) => {
        this.alertService.warning(translation);
      });
    }
  }

  // Funkcja ładująca kampanie z zastosowaniem filtrów
  loadCampaigns(inPlace: boolean = false): void {
    // inPlace=true (manualny/auto Odśwież): NIE chowaj tabeli — tylko lekki wskaznik,
    // dzieki czemu wysokosc strony sie nie zmienia i przegladarka nie skacze na gore.
    if (inPlace) {
      this.isReloading = true;
    } else {
      this.isLoading = true;
    }
    //this.stopAllPolling();
    this.errorMessage = "";
    console.log("laduje kampanie!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");

    // Kazde odswiezenie ZAMYKA wszystkie rozwiniete konwersacje (i zatrzymuje ich chat-polling).
    // Dlatego NIE przywracamy stanu rozwiniecia po reloadzie — existingState zostaje puste.
    Object.keys(this.pollingSubscriptions).forEach((key) =>
      this.stopPollingForChat(key)
    );
    this.expandedCampaign = null;
    const existingState: Record<
      number,
      { expandedIndex: number | null; expanded: boolean }
    > = {};

    const existingTags = this.campaigns.reduce((acc, campaign) => {
      acc[campaign.id] = campaign.tagsLetters || [];
      return acc;
    }, {} as Record<number, any[]>);

    // Prepare filters
    const filters = this.filtersApplied ? this.buildFilters() : {};

    // Make backend call to fetch campaigns
    this.addressBookService
      .getPaginatedCampaigns(
        this.campaignPublic,
        this.currentPage,
        this.pageSize,
        this.sortBy,
        this.sortOrder,
        filters
      )
      .subscribe({
        next: (response: {
          data: Campaign[];
          pagination: { total: number };
        }) => {
          this.processCampaigns(response.data, existingState, existingTags);
          this.updatePagination(response.pagination.total);
          this.startPolling();
          this.isLoading = false;
          this.isReloading = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error("Error fetching campaigns:", err); // Log the error
          console.log("Applied filters:", filters); // Log the applied filters
          this.handleFilterError(err, filters); // Pass the filters as the second argument
        },
      });
  }

  private buildFilters(): Record<string, any> {
    const filters: any = {};

    if (this.filterValues.type) filters.type = +this.filterValues.type;
    if (this.filterValues.status) filters.status = +this.filterValues.status;
    if (this.filterValues.phone && this.filterValues.phone.length >= 3)
      filters.phone = this.filterValues.phone;
    if (
      this.filterValues.call_number !== null &&
      this.filterValues.call_number >= 0
    )
      filters.call_number = +this.filterValues.call_number;
    if (this.filterValues.call_at) filters.call_at = +this.filterValues.call_at;
    if (this.filterValues.created) filters.created = +this.filterValues.created;
    if (this.filterValues.modified)
      filters.modified = +this.filterValues.modified;
    if (this.filterValues.scheduled !== null)
      filters.scheduled = +this.filterValues.scheduled;
    if (this.filterValues.tag) filters.tag = +this.filterValues.tag;

    return Object.keys(filters).length > 0 ? filters : {};
  }

  private handleFilterError(error: any, filters: Record<string, any>): void {
    this.isLoading = false;
    this.isReloading = false;

    const filtersApplied = Object.keys(filters).length > 0;

    // VoiceBot zwraca 404/500, gdy zaden kontakt nie pasuje do filtrow.
    // Traktuj to jako PUSTY wynik filtrowania — pokaz przefiltrowana, pusta tabele
    // (zamiast bledu lub fallbacku do niefiltrowanych danych).
    if (filtersApplied && (error?.status === 404 || error?.status === 500)) {
      this.campaigns = [];
      this.updatePagination(0);
      this.errorMessage = "";
      this.cdr.detectChanges();
      return;
    }

    // Pozostale bledy
    if (typeof error === "string") {
      this.errorMessage = `An error occurred: ${error}`;
    } else if (error?.status === 400) {
      this.errorMessage =
        "Bad request. Please review the filters and try again.";
    } else {
      this.translate
        .get("TRANSLATIONS.FAILED_TO_APPLY_FILTERS")
        .subscribe((res: string) => {
          this.errorMessage = res;
        });
    }

    this.cdr.detectChanges();
  }

  private processCampaigns(
    campaigns: Campaign[],
    existingState: Record<
      number,
      { expandedIndex: number | null; expanded: boolean }
    >,
    existingTags: Record<number, any[]>
  ): void {
    this.campaigns = campaigns.map((campaign) => {
      const restoredState = existingState[campaign.id];
      return {
        ...campaign,
        expanded: restoredState?.expanded ?? false,
        expandedIndex: restoredState?.expandedIndex ?? null,
        chatMessagesSubject: new BehaviorSubject<ChatMessage[]>([]),
        tagsLetters:
          campaign.tags.length > 0
            ? this.mapTags(campaign.tags)
            : existingTags[campaign.id] || [],
      };
    });
  }

  private updatePagination(totalItems: number): void {
    this.totalItems = totalItems;
    this.totalPages = Math.ceil(this.totalItems / this.pageSize);
    this.startItem = (this.currentPage - 1) * this.pageSize + 1;
    this.endItem = Math.min(this.currentPage * this.pageSize, this.totalItems);

    this.generatePageNumbers();
  }

  private handleError(error: any): void {
    this.isLoading = false;
    this.errorMessage = "Failed to load campaigns.";
    console.error("Error loading campaigns:", error);
    this.cdr.detectChanges();
  }

  // Mapa tagów
  mapTags(tags: any[]): any[] {
    if (!tags || tags.length === 0) return [];
    return tags.map((tag: any) => ({
      letter: tag.value.charAt(0).toUpperCase(),
      color: tag.color,
      fullName: tag.value,
      tooltip: tag.value,
    }));
  }

  onRetryContact(campaignPublic: string): void {
    // Kampania tylko przychodzaca (type === 0) — ponawianie nie ma sensu, blokuj.
    if (this.selectedCampaignType === 0) {
      return;
    }
    // Find the campaign by its public identifier
    const campaign = this.campaigns.find((c) => c.public === campaignPublic);
    // Block retry for contacts with retry == 0, status == 0, and scheduled != null
    if (campaign?.retry === 0 && campaign.status === 0 && campaign.scheduled) {
      console.warn(this.translate.instant("ERROR.RETRY_BLOCKED_LOG"));
      this.showErrorModal(this.translate.instant("ERROR.RETRY_BLOCKED"));
      return;
    }

    // Obsluga lokalna (jak szybkie akcje) — niezawodne odswiezenie po sukcesie.
    // Auto-polling wylaczony, wiec po udanym ponowieniu wolamy refreshTable().
    const modalRef = this.modalService.open(RetryContactModalComponent, {
      centered: true,
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.isLoading = true;
    modalRef.componentInstance.isSuccess = false;

    this.campaignsService.retryContact(campaignPublic).subscribe(
      () => {
        this.refreshTable(); // odswiez widok po ponowieniu
        setTimeout(() => {
          modalRef.componentInstance.isLoading = false;
          modalRef.componentInstance.isSuccess = true;
          modalRef.componentInstance.closeAfterSuccess();
        }, 2000);
      },
      (error) => {
        console.error("Failed to retry contact:", error);
        modalRef.dismiss();
        this.showErrorModal(
          (error && error.message) ||
            "Failed to retry contact. Please try again later."
        );
      }
    );
  }

  onSort(column: string): void {
    if (this.sortBy === column) {
      if (this.sortOrder === "asc") {
        this.sortOrder = "desc";
      } else if (this.sortOrder === "desc") {
        this.sortOrder = "";
        this.sortBy = "";
      } else {
        this.sortOrder = "asc";
      }
    } else {
      this.sortBy = column;
      this.sortOrder = "asc";
    }

    this.loadCampaigns();
  }

  getSortIcon(column: string): string {
    if (this.sortBy === column) {
      if (this.sortOrder === "asc") {
        return "fa fa-sort-up ms-2 fs-9";
      } else if (this.sortOrder === "desc") {
        return "fa fa-sort-down ms-2 fs-9";
      }
    }
    return "fa fa-sort ms-2 fs-9";
  }

  generatePageNumbers(): void {
    const totalPages = this.totalPages;
    const currentPage = this.currentPage;

    if (totalPages <= 5) {
      // Show all pages if total pages are 5 or less
      this.pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      const pages = [];
      pages.push(1); // Always show the first page

      if (currentPage > 3) {
        pages.push("..."); // Ellipsis before the current page range
      }

      const start = Math.max(2, currentPage - 2);
      const end = Math.min(totalPages - 1, currentPage + 2);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 2) {
        pages.push("...");
      }

      pages.push(totalPages); // Always show the last page
      this.pageNumbers = pages;
    }
  }

  onPageChange(page: number | string): void {
    if (typeof page === "number" && page > 0 && page <= this.totalPages) {
      this.currentPage = page;
      this.loadCampaigns(); // Reload campaigns for the new page along with filters
    }
  }

  // --- Skok do strony przez klikniecie wielokropka (...) w paginacji ---
  editingPageIndex: number | null = null; // ktory "..." jest aktualnie edytowany
  pageInputValue: number | null = null;

  startPageJump(index: number): void {
    this.editingPageIndex = index;
    this.pageInputValue = null;
  }

  cancelPageJump(): void {
    this.editingPageIndex = null;
    this.pageInputValue = null;
  }

  goToPage(): void {
    const page = Number(this.pageInputValue);
    if (Number.isInteger(page) && page >= 1 && page <= this.totalPages) {
      this.cancelPageJump();
      this.onPageChange(page);
    }
  }

  truncateString(value: string, length: number = 3): string {
    return value.length > length ? value.substring(0, length) + "..." : value;
  }

  copyToClipboard(value: string, event: MouseEvent): void {
    event.stopPropagation(); // Prevent row expansion when clicking the copy icon

    // Use the Clipboard API to copy the text
    navigator.clipboard
      .writeText(value)
      .then(() => {
        // Show a success toast using the ToastService
        this.translate.get("TOAST.SUCCESS_COPY").subscribe((res: string) => {
          this.toastService.showToast(res);
        });

        // If the copied value is a phone number, update tooltip and open it
        if (value.length >= 10) {
          this.copiedPhone = value;
          this.tooltipMessage = "Copied!";

          // Access the tooltip directly from the event target
          const tooltipElement = (event.target as HTMLElement)
            .closest("span")
            ?.querySelector("[ngbTooltip]") as any;

          // Open the tooltip if it's available
          if (tooltipElement) {
            tooltipElement.open(); // Show the tooltip with 'Copied!'

            // Automatically close the tooltip after 2 seconds
            setTimeout(() => {
              tooltipElement.close();
            }, 2000);
          }
        }
      })
      .catch((err) => {
        console.error("Could not copy text: ", err);
        // Show an error toast in case of failure
        this.translate.get("TOAST.FAILED_COPY").subscribe((res: string) => {
          this.toastService.showToast(res);
        });
      });
  }

  // Reczne odswiezenie tabeli — wywolywane przyciskiem "Odśwież" (auto-polling wylaczony).
  // Zachowuje biezaca strone, sortowanie i zastosowane filtry (loadCampaigns sam je uwzglednia).
  // Odswiezenie "w miejscu" — uzywane wewnetrznie (po tagu/retry/statusie) ORAZ przez auto-odswiezanie.
  // NIE wylacza auto-odswiezania.
  refreshTable(): void {
    this.loadCampaigns(true); // in-place — bez chowania tabeli i skoku scrolla
  }

  // Reczne klikniecie przycisku "Odśwież" w widoku — wylacza auto-odswiezanie.
  onManualRefresh(): void {
    this.stopAutoRefresh();
    this.loadCampaigns(true);
  }

  // Stabilizuje wiersze przy odswiezaniu w miejscu (brak pelnej przebudowy DOM).
  trackByCampaignId(_index: number, campaign: Campaign): number {
    return campaign.id;
  }

  // Przelacznik opcjonalnego auto-odswiezania (co 10s).
  toggleAutoRefresh(): void {
    if (this.autoRefreshEnabled) {
      this.stopAutoRefresh();
    } else {
      this.startAutoRefresh();
    }
  }

  // Zwija wszystkie rozwiniete transkrypcje i zatrzymuje ich chat-polling.
  private collapseAllTranscriptions(): void {
    this.campaigns.forEach((campaign) => {
      if (campaign.expanded) {
        campaign.expanded = false;
        this.stopPollingForChat(campaign.public);
      }
    });
    this.expandedCampaign = null;
  }

  private startAutoRefresh(): void {
    if (this.autoRefreshEnabled) {
      return;
    }
    this.collapseAllTranscriptions(); // Wlaczenie auto-odswiezania chowa rozwiniete transkrypcje
    this.autoRefreshEnabled = true;
    // Od razu wykonaj odswiezenie (pierwszy tick interwalu dopiero po 10s).
    if (!this.isLoading && !this.isReloading) {
      this.loadCampaigns(true);
    }
    this.autoRefreshSub = interval(this.AUTO_REFRESH_MS).subscribe(() => {
      // Nie nakladaj kolejnego zapytania, jesli poprzednie jeszcze trwa.
      if (!this.isLoading && !this.isReloading) {
        this.loadCampaigns(true); // in-place — bez chowania tabeli i skoku scrolla
      }
    });
    this.cdr.detectChanges();
  }

  // Wylacza auto-odswiezanie (manualny Odśwież, filtr, rozwinieta rozmowa).
  stopAutoRefresh(): void {
    if (this.autoRefreshSub) {
      this.autoRefreshSub.unsubscribe();
      this.autoRefreshSub = undefined;
    }
    if (this.autoRefreshEnabled) {
      this.autoRefreshEnabled = false;
      this.cdr.detectChanges();
    }
  }

  startPolling(): void {
    // Auto-odswiezanie (polling) wylaczone — dane odswieza recznie przycisk "Odśwież" (refreshTable()).
    // Metoda zostawiona jako no-op, zeby nie zmieniac wszystkich miejsc, ktore ja wywoluja.
    return;

    // Check if polling is already running, if yes, do nothing
    if (this.pollingSubscription) {
      return; // Exit if polling is already active
    }

    // Start polling every 3 seconds
    this.pollingSubscription = interval(5000)
      .pipe(
        startWith(0), // Start immediately
        switchMap(() => {
          const filters = {
            type: this.filterValues.type ? +this.filterValues.type : undefined,
            status: this.filterValues.status
              ? +this.filterValues.status
              : undefined,
            phone:
              this.filterValues.phone?.length >= 3
                ? this.filterValues.phone
                : undefined,
            call_number: this.filterValues.call_number
              ? +this.filterValues.call_number
              : undefined,
            created: this.filterValues.created
              ? +this.filterValues.created
              : undefined,
            modified: this.filterValues.modified
              ? +this.filterValues.modified
              : undefined,
            scheduled: this.filterValues.scheduled
              ? +this.filterValues.scheduled
              : undefined,
          };

          // Fetch campaigns with pagination, sorting, and filters
          return this.addressBookService.getPaginatedCampaigns(
            this.campaignPublic,
            this.currentPage,
            this.pageSize,
            this.sortBy ? this.sortBy : undefined,
            this.sortOrder ? this.sortOrder : undefined,
            filters
          );
        })
      )
      .subscribe(
        (response: { data: Campaign[]; pagination: { total: number } }) => {
          const expandedCampaignId = this.expandedCampaign
            ? this.expandedCampaign.id
            : null;

          // Preserve expanded state and other necessary data
          const existingState = this.campaigns.reduce((acc, campaign) => {
            acc[campaign.id] = {
              expandedIndex: campaign.expandedIndex ?? null,
              expanded: campaign.expanded ?? false,
            };
            return acc;
          }, {} as { [key: number]: { expandedIndex: number | null; expanded: boolean } });

          const existingTags = this.campaigns.reduce((acc, campaign) => {
            acc[campaign.id] = campaign.tagsLetters ?? [];
            return acc;
          }, {} as { [key: number]: any[] });

          // Update the campaign list
          this.campaigns = response.data.map((campaign) => {
            const restoredState = existingState[campaign.id] || {
              expanded: false,
              expandedIndex: null,
            };

            if (restoredState.expandedIndex !== null) {
              return {
                ...campaign,
                expanded: restoredState.expanded,
                expandedIndex: restoredState.expandedIndex,
                chatMessagesSubject: new BehaviorSubject<ChatMessage[]>([]),
                tagsLetters: existingTags[campaign.id] || [],
              };
            }

            return {
              ...campaign,
              expanded: false,
              expandedIndex: null,
              chatMessagesSubject: new BehaviorSubject<ChatMessage[]>([]),
              tagsLetters:
                campaign.tags.length > 0
                  ? this.mapTags(campaign.tags)
                  : existingTags[campaign.id] || [],
            };
          });

          // Handle pagination
          this.totalItems = response.pagination?.total ?? 0;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
          this.startItem = (this.currentPage - 1) * this.pageSize + 1;
          this.endItem = Math.min(
            this.currentPage * this.pageSize,
            this.totalItems
          );

          this.generatePageNumbers();

          // Restore expanded campaign state
          if (expandedCampaignId) {
            const expandedCampaign = this.campaigns.find(
              (campaign) => campaign.id === expandedCampaignId
            );
            if (expandedCampaign && expandedCampaign.expanded) {
              this.expandedCampaign = expandedCampaign;
              this.loadChatMessages(expandedCampaign);
              this.startPollingForChat(expandedCampaign.public);
            }
          } else {
            this.expandedCampaign = null;
          }

          this.isLoading = false;
          this.cdr.detectChanges();
        },
        (error) => {
          this.isLoading = false;

          // Log the entire error object for debugging
          console.log("Error object:", error);

          // Check if error is an instance of HttpErrorResponse
          if (error instanceof HttpErrorResponse) {
            console.log("HTTP Error Status:", error.status);

            // Handle specific status codes
            switch (error.status) {
              case 500:
                console.error(
                  "Server error occurred (500):",
                  error.error?.message || error.message
                );
                this.resetFilters();
                break;
              case 400:
                console.error(
                  "Bad request (400):",
                  error.error?.message || error.message
                );
                this.resetFilters();
                break;
              default:
                console.error(
                  `Unexpected HTTP error (${error.status}):`,
                  error.error?.message || error.message
                );
                this.resetFilters();
                break;
            }
          } else {
            console.error("Non-HTTP error occurred:", error);
            this.resetFilters();
          }

          // Display a generic error message
          this.translate
            .get("ERROR.FAILED_TO_LOAD_CAMPAIGNS")
            .subscribe((res: string) => {
              this.errorMessage = res;
            });

          this.selectedCampaignType = null;
          this.cdr.detectChanges();
        }
      );
  }

  stopAllPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
      this.pollingSubscription = undefined; // Set to undefined instead of null
    }

    // Stop all chat pollings if needed
    Object.keys(this.pollingSubscriptions).forEach((key) => {
      this.stopPollingForChat(key);
    });
  }

  toggleExpandRow(campaign: Campaign, rowElement: HTMLElement): void {
    // Only allow expanding for status 2 (answered) and 4 (rejected)
    if (campaign.status !== 2 && campaign.status !== 4) {
      return;
    }

    // Collapse any previously expanded campaign
    if (this.expandedCampaign && this.expandedCampaign !== campaign) {
      this.expandedCampaign.expanded = false;
      this.stopPollingForChat(this.expandedCampaign.public); // Stop polling for the old campaign
      this.expandedCampaign = null;
    }

    // Toggle the expansion of the clicked campaign
    campaign.expanded = !campaign.expanded;

    if (campaign.expanded) {
      // Set the currently expanded campaign
      this.expandedCampaign = campaign;
      this.stopAutoRefresh(); // Rozwiniecie rozmowy wylacza auto-odswiezanie
      this.pollingSubscription?.unsubscribe(); // Stop general polling

      // Load chat messages and start polling for this campaign
      this.loadChatMessages(campaign);
      this.startPollingForChat(campaign.public);

      // Scroll to the expanded row smoothly
      setTimeout(() => {
        this.scrollToRow(rowElement);
      }, 100);
    } else {
      // If the campaign is collapsed, stop polling for chat
      this.stopPollingForChat(campaign.public);
      this.expandedCampaign = null;
      this.startPolling(); // Restart general polling
    }

    // Trigger change detection to update the view
    this.cdr.markForCheck();
  }

  // Zwija rozwinieta transkrypcje (przycisk X w rozwinietym obszarze).
  collapseTranscription(campaign: Campaign, event: Event): void {
    event.stopPropagation();
    campaign.expanded = false;
    this.stopPollingForChat(campaign.public);
    this.expandedCampaign = null;
    this.startPolling();
    this.cdr.markForCheck();
  }

  scrollToRow(rowElement: HTMLElement): void {
    if (rowElement) {
      rowElement.scrollIntoView({ behavior: "smooth", block: "start" });

      setTimeout(() => {
        window.scrollBy({
          top: -70,
          left: 0,
          behavior: "smooth",
        });
      }, 500);
    }
  }

  scrollToChatRow(expandedCampaign: Campaign): void {
    const rowIndex = this.campaigns.indexOf(expandedCampaign);
    if (rowIndex !== -1) {
      const chatRowElement = this.chatRows.toArray()[rowIndex];
      if (chatRowElement) {
        chatRowElement.nativeElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }

  openChatModal(content: TemplateRef<any>) {
    this.modalService
      .open(content, {
        ariaLabelledBy: "modal-basic-title",
        size: "lg",
        backdrop: "static",
      })
      .result.then(
        (result) => {
          console.log("Modal closed with: ", result);
        },
        (reason) => {
          console.log("Modal dismissed with: ", reason);
        }
      );
  }

  closeChatModal() {
    this.modalService.dismissAll(); // Close the modal
  }

  loadChatMessages(campaign: Campaign): void {
    this.addressBookService
      .getTranscriptionsByPublic(campaign.public)
      .subscribe(
        (response) => {
          campaign.chatMessagesSubject.next(response.data);
          this.cdr.detectChanges();
        },
        (error) => {
          console.error("Error loading chat messages:", error);
        }
      );
  }

  playTranscriptionAudio(campaign: Campaign, event: MouseEvent): void {
    event.stopPropagation(); // Prevent triggering other events

    // Stop all current polling (if needed, this might depend on your use case)
    this.stopAllPolling();

    // If a different campaign's audio is playing, close the current dialog before opening a new one
    if (
      this.currentCampaignPlaying &&
      this.currentCampaignPlaying !== campaign
    ) {
      if (this.isAudioDialogOpen) {
        this.dialog.closeAll(); // Close the currently open audio dialog
      }
    }

    // Check if the current campaign is already playing
    if (this.currentCampaignPlaying === campaign) {
      this.togglePlayPause();
      return;
    }

    // Fetch audio URL and open the dialog
    this.addressBookService
      .getTranscriptionAudioByPublic(campaign.public)
      .subscribe(
        (response) => {
          const audioDataUrl = response.data;

          // Set the campaign currently playing
          this.currentCampaignPlaying = campaign;

          // Open the new audio modal
          this.openAudioModal(
            audioDataUrl,
            campaign.public,
            this.translate.instant("CAMPAIGN.NAME")
          );
        },
        (error) => {
          console.error("Error fetching transcription audio:", error);
          this.alertService.error(
            this.translate.instant("ERROR.ERROR_FETCHING_AUDIO")
          );
        }
      );
  }

  togglePlayPause(): void {
    if (this.currentAudio) {
      if (this.isPaused) {
        this.currentAudio.play();
        this.isPaused = false;
      } else {
        this.currentAudio.pause();
        this.isPaused = true;
      }
      this.cdr.detectChanges();
    }
  }

  openAudioModal(
    audioUrl: string,
    campaignName: string,
    kampaniaName: string
  ): void {
    // Check if an audio dialog is already open and close it before opening a new one
    if (this.isAudioDialogOpen) {
      this.dialog.closeAll(); // This ensures that any previous dialog is closed
    }

    // Set the flag indicating that an audio dialog is open
    this.isAudioDialogOpen = true;

    // Open the audio modal dialog
    const dialogRef = this.dialog.open(AudioModalComponent, {
      data: { audioUrl, campaignName, kampaniaName }, // Pass the audio URL and names
      disableClose: true, // Disable closing by clicking outside the dialog
      panelClass: "custom-dialog-class",
    });

    // Subscribe to the `afterClosed` event to reset the dialog state when it is closed
    dialogRef.afterClosed().subscribe(() => {
      this.isAudioDialogOpen = false;
      this.currentCampaignPlaying = null; // Reset the currently playing campaign
      this.startPolling(); // Restart polling after the dialog is closed (if needed)
    });
  }

  quickActionPhoneMissed(campaign: Campaign, event: Event): void {
    event.stopPropagation();

    // Check if there is an audio dialog open and close it
    if (this.isAudioDialogOpen) {
      this.dialog.closeAll(); // Close all dialogs, including audio dialog
      this.isAudioDialogOpen = false;
    }

    // If the clicked campaign is currently playing audio, pause it and reset the state
    if (this.currentCampaignPlaying === campaign && this.currentAudio) {
      this.currentAudio.pause();
      this.currentCampaignPlaying = null;
    }

    // If the campaign is expanded, collapse it and reset the expandedCampaign reference
    if (campaign.expanded) {
      campaign.expanded = false;
      this.expandedCampaign = null;
    }

    // Stop polling for the entire list before making changes
    this.stopAllPolling();

    // Change the campaign's status and display a success message
    this.changeStatus(campaign, 3);

    // Display a success message
    this.alertService.success(
      this.translate.instant("CAMPAIGN.ACTION_SUCCESS")
    );

    // Restart polling for the entire list
    this.startPolling();
  }

  quickActionPhoneRejected(campaign: Campaign, event: Event): void {
    event.stopPropagation();

    // Check if there is an audio dialog open and close it
    if (this.isAudioDialogOpen) {
      this.dialog.closeAll(); // Close all dialogs, including audio dialog
      this.isAudioDialogOpen = false;
    }

    // If the clicked campaign is currently playing audio, pause it and reset the state
    if (this.currentCampaignPlaying === campaign && this.currentAudio) {
      this.currentAudio.pause();
      this.currentCampaignPlaying = null;
    }

    // If the campaign is expanded, collapse it and reset the expandedCampaign reference
    if (campaign.expanded) {
      campaign.expanded = false;
      this.expandedCampaign = null;
    }

    // Stop polling for the entire list before making changes
    this.stopAllPolling();

    // Change the campaign's status and display a success message
    this.changeStatus(campaign, 4);

    // Display a success message
    this.alertService.success(
      this.translate.instant("CAMPAIGN.ACTION_SUCCESS")
    );

    // Restart polling for the entire list
    this.startPolling();
  }

  // openAudioModal(audioUrl: string): void {
  //   const dialogRef = this.dialog.open(AudioModalComponent, {
  //     data: { audioUrl },
  //     disableClose: true,
  //     panelClass: 'custom-dialog-class', // Make sure this class is defined with the correct z-index
  //   });

  //   dialogRef.componentInstance.audioUrl = audioUrl;

  //   dialogRef.afterClosed().subscribe(() => {
  //     console.log('Modal closed');
  //     this.startPolling();
  //   });
  // }

  // hasMessages(campaign: Campaign): boolean {
  //   console.log('campaign.chatMessagesSubject ',campaign.chatMessagesSubject)
  //   return campaign.chatMessagesSubject && campaign.chatMessagesSubject.value.length > 0;
  // }

  showErrorModal(message: string): void {
    this.alertService.error(message);
  }

  startPollingForChat(campaignPublic: string): void {
    if (!this.pollingSubscriptions[campaignPublic]) {
      this.pollingSubscriptions[campaignPublic] = interval(3000)
        .pipe(
          switchMap(() =>
            this.addressBookService.getTranscriptionsByPublic(campaignPublic)
          )
        )
        .subscribe((response) => {
          const campaign = this.campaigns.find(
            (c) => c.public === campaignPublic
          );
          if (campaign) {
            campaign.chatMessagesSubject.next(response.data);
            this.cdr.detectChanges();
          }
        });
    }
  }

  stopPollingForChat(campaignPublic: string): void {
    if (this.pollingSubscriptions[campaignPublic]) {
      this.pollingSubscriptions[campaignPublic].unsubscribe();
      delete this.pollingSubscriptions[campaignPublic];
    }
  }

  formatCampaignDuration(duration: number): string {
    const hours = Math.floor(duration / 3600)
      .toString()
      .padStart(2, "0");
    const minutes = Math.floor((duration % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (duration % 60).toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  }

  formatDuration(duration: number): string {
    const hours = Math.floor(duration / 3600)
      .toString()
      .padStart(2, "0");
    const minutes = Math.floor((duration % 3600) / 60)
      .toString()
      .padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  changeStatus(campaign: Campaign, status: number, event?: Event): void {
    if (event) {
      event.preventDefault();
    }

    this.stopAllPolling();

    this.addressBookService
      .updatePhoneNumberStatus(campaign.public, { status })
      .subscribe(
        (response) => {
          campaign.status = status;

          if (campaign.expanded) {
            campaign.expanded = false;

            this.stopPollingForChat(campaign.public);

            if (this.expandedCampaign === campaign) {
              this.expandedCampaign = null;
            }

            campaign.chatMessagesSubject.next([]);
          }

          this.loadCampaigns();

          this.startPolling();

          this.cdr.detectChanges();
        },
        (error) => {
          console.error("Error updating phone number status:", error);

          this.startPolling();
        }
      );
  }

  openEditStatusModal(campaign: Campaign, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    let allowedStatuses: number[] = [];
    const allPossibleStatuses = [0, 1, 2, 3, 4, 5, 6];

    if (this.authService.hasRole(["superadmin", "admin"])) {
      allowedStatuses = allPossibleStatuses;
    } else {
      allowedStatuses.push(campaign.status);

      if (campaign.status === 3) {
        if (!allowedStatuses.includes(6)) {
          allowedStatuses.push(6);
        }
      }
    }

    const modalRef = this.modalService.open(EditStatusContactModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.campaign = campaign;
    modalRef.componentInstance.allowedStatuses = allowedStatuses;

    modalRef.result
      .then((newStatus) => {
        // Modal zamyka sie wartoscia z <select> (string np. "3") lub number — akceptuj oba.
        if (newStatus !== undefined && newStatus !== null) {
          this.refreshTable(); // Odswiez widok po zapisaniu statusu (auto-polling wylaczony)
          this.cdr.detectChanges();
        }
      })
      .catch(() => {});
  }

  onModalClose(): void {
    this.isModalVisible = false;
    this.selectedCampaign = null;
  }

  onStatusSave(newStatus: number): void {
    if (this.selectedCampaign) {
      this.changeStatus(this.selectedCampaign, newStatus);
    }
    this.onModalClose();
  }

  getScheduledTranslation(): string {
    return this.translate.instant("CAMPAIGN.SCHEDULED");
  }

  getNoScheduledTranslation(): string {
    return this.translate.instant("CAMPAIGN.NO_SCHEDULED");
  }

  getIconClass(status: number): string {
    return status === 2 || status === 4 ? "text-success" : "text-muted";
  }

  toggleFullId(campaign: Campaign): void {
    campaign.showFullId = !campaign.showFullId;
  }

  getIcons(
    status: number,
    scheduled: string | null
  ): { icon: string; tooltip: string } {
    let tooltipKey: string;
    if (status === 0 && scheduled) {
      const formattedDate = this.timezoneDatePipe.transform(scheduled);
      tooltipKey = "TOOLTIP.SCHEDULED_QUEUE";
      return {
        icon: "fa-solid fa-hourglass-clock text-info",
        tooltip: `${this.translate.instant(tooltipKey)} \n ${formattedDate}`,
      };
    }

    switch (status) {
      case 0:
        tooltipKey = "TOOLTIP.IN_QUEUE"; // Corresponds to "numer w kolejce"
        return this.getTooltipWithIcon("fa-solid fa-phone", tooltipKey);

      case 1:
        tooltipKey = "TOOLTIP.TAKEN_FOR_CALL"; // Corresponds to "numer pobrany do wybrania"
        return this.getTooltipWithIcon("fa-solid fa-phone-volume", tooltipKey);

      case 2:
        tooltipKey = "TOOLTIP.CALL_RECEIVED"; // Corresponds to "połączenie zostało odebrane"
        return this.getTooltipWithIcon("fa-solid fa-phone", tooltipKey);

      case 3:
        tooltipKey = "TOOLTIP.CALL_MISSED"; // Corresponds to "połączenie nieodebrane"
        return this.getTooltipWithIcon("fa-solid fa-phone-missed", tooltipKey);

      case 4:
        tooltipKey = "TOOLTIP.CALL_REJECTED"; // Corresponds to "połączenie odrzucone"
        return this.getTooltipWithIcon("fa-solid fa-phone-slash", tooltipKey);

      case 5:
        tooltipKey = "TOOLTIP.CALL_ERROR"; // Corresponds to "błąd połączenia"
        return this.getTooltipWithIcon(
          "fa-solid fa-triangle-exclamation",
          tooltipKey
        );

      case 6:
        tooltipKey = "TOOLTIP.CALL_CANCELED"; // Corresponds to "połączenie anulowane"
        return this.getTooltipWithIcon("fa-solid fa-ban", tooltipKey);

      default:
        tooltipKey = "TOOLTIP.UNKNOWN"; // Default case for unknown status
        return this.getTooltipWithIcon(
          "fa-solid fa-circle-question",
          tooltipKey
        );
    }
  }

  getTooltipWithIcon(iconClass: string, tooltipKey: string): any {
    let tooltipText = "";

    this.translate.get(tooltipKey).subscribe((translatedText) => {
      tooltipText = translatedText;
    });

    return {
      icon: iconClass,
      tooltip: tooltipText,
    };
  }

  getSyncIcon(syncStatus: number): { icon: string; tooltip: string } {
    switch (syncStatus) {
      case 0:
        return {
          icon: "fa-hourglass-start text-info",
          tooltip: this.translate.instant("SYNC.PENDING"),
        };
      case 1:
        return {
          icon: "fa-check text-success",
          tooltip: this.translate.instant("SYNC.SYNCED"),
        };
      case 2:
        return {
          icon: "fa-times-circle text-danger",
          tooltip: this.translate.instant("SYNC.ERROR"),
        };
      default:
        return {
          icon: "fa-question-circle text-muted",
          tooltip: this.translate.instant("SYNC.UNKNOWN"),
        };
    }
  }

  getFormattedSyncDate(syncDate: string | number): string {
    if (syncDate === "0" || syncDate === 0) {
      return "-";
    }
    return new Date(syncDate).toLocaleDateString();
  }

  getStatusClass(status: number): string {
    switch (status) {
      case 0:
        return "text-info";
      case 1:
        return "text-info";
      case 2:
        return "text-success";
      case 3:
        return "text-danger";
      case 4:
        return "text-warning";
      case 5:
        return "text-primary";
      case 6:
        return "text-danger";
      default:
        return "text-muted";
    }
  }

  getStatusText(status: number): string {
    switch (status) {
      case 0:
        return this.translate.instant("STATUS.QUEUE");
      case 1:
        return this.translate.instant("STATUS.PICKED_FOR_DIALING");
      case 2:
        return this.translate.instant("STATUS.CALL_ANSWERED");
      case 3:
        return this.translate.instant("STATUS.CALL_MISSED");
      case 4:
        return this.translate.instant("STATUS.CALL_REJECTED");
      case 5:
        return this.translate.instant("STATUS.CALL_ERROR");
      case 6:
        return this.translate.instant("STATUS.CALL_CANCELED");
      default:
        return this.translate.instant("STATUS.UNKNOWN");
    }
  }

  loadPhoneBadgeColors(): void {
    this.phoneNumbersService.getPhoneBadgeColors().subscribe({
      next: (phones: any[]) => {
        this.phoneColorMap = new Map(
          phones.map((p) => [p.phone_number, p.badge_color])
        );
      },
      error: (err) => {
        console.error("Failed to load phone badge colors:", err);
      },
    });
  }

  getPhoneColor(phone: string): string {
    return this.phoneColorMap.get(phone) || "#6c757d"; // fallback to gray (Bootstrap secondary)
  }
}
